import React, { useEffect, useState } from 'react'
import { Link, Head, useForm } from '@inertiajs/inertia-react';
import ApplicationLogo from '@/Components/ApplicationLogo';
import Radio from '@/Components/Radio';
import { Inertia } from '@inertiajs/inertia';
import { isJuly, isWeekend } from '@/helpers/date';

const ScheduleType = ({ store, branchOffice }) => {
    const [typeSelected, setTypeSelected] = useState(null);
    const [tabSelected, setTabSelected] = useState('individual');

    const handlePrice = (type) => {
        const today = new Date()
        return (isWeekend(today) || isJuly(today) || isHoliday(today)) ? type.weekend_price : type.price 
    }

    const handleNextStep = (e) => {
        e.preventDefault()
        if (typeSelected) {
            return Inertia.visit(`/patinaje/${branchOffice.slug}/${typeSelected.id}`)
        }
    }

    useEffect(() => {
        setTypeSelected(null);
    }, [tabSelected])

    return (
        <>
            <Head title="Selección de hora - Cerogrado" />
            <div className="relative  items-top  min-h-screen bg-gray-100 sm:items-center sm:pt-0">
                <div className="text-center">
                    <ApplicationLogo className="mx-auto" store={store} />
                    <div className="pb-20 pt-10">
                        {/* <h1 className="text-lg">Ven a divertirte al mejor parque de patinaje de todo Chile. Lorem ipsum...</h1> */}
                        <h2 className="text-2xl font-bold">Selecciona un periodo.</h2>

                    </div>
                </div>

                <div className="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">

                    {
                        branchOffice && branchOffice.schedule_types && branchOffice.schedule_types.length > 0 ?
                            <>
                                <div className="w-full grid grid-cols-2 gap-5 mx-auto sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                                    <button onClick={() => setTabSelected('individual')} className={`px-3 py-1 rounded ${tabSelected === 'individual' ? 'bg-primary text-white font-bold' : 'bg-gray-200'}`}>Individual</button>
                                    <button onClick={() => setTabSelected('group')} className={`px-3 py-1 rounded ${tabSelected === 'group' ? 'bg-primary text-white font-bold' : 'bg-gray-200'}`}>Grupal</button>
                                </div>

                                <div className="w-full mx-auto sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                                    <form className="mx-auto">
                                        <h2 className='mb-4 text-center text-gray-900 text-lg font-bold'>Periodos disponibles</h2>

                                        {
                                            tabSelected === 'individual' && branchOffice.schedule_types.filter(type => !type.is_group).map((type, key) => (
                                                <Radio
                                                    key={key}
                                                    value={type}
                                                    binding={typeSelected}
                                                    name='schedule_type'
                                                    handleChange={(event)=> {
                                                        setTypeSelected(type)
                                                    }}
                                                >
                                                    {type.schedule_description} - ${handlePrice(type)}
                                                </Radio>
                                            ))
                                        }

                                        {
                                            tabSelected === 'group' && branchOffice.schedule_types.filter(type => type.is_group).map((type, key) => (
                                                <Radio
                                                    key={key}
                                                    value={type}
                                                    binding={typeSelected}
                                                    name='schedule_type'
                                                    handleChange={(event)=> {
                                                        setTypeSelected(type)
                                                    }}
                                                >
                                                    {type.schedule_description} - ${handlePrice(type)}
                                                </Radio>
                                            ))
                                        }


                                        <div className="flex items-center justify-center mt-8">
                                            
                                            <button disabled={!typeSelected} className={`p-3 ${typeSelected ? 'bg-black' : 'bg-gray-400 cursor-not-allowed'} text-white rounded`}
                                                onClick={handleNextStep}
                                            >Continuar</button>
                                        </div>
                                    </form>
                                </div>
                            </>
                            :
                            <div className='text-center text-xl font-bold mt-8 text-gray-700'>
                                Lo sentimos, pero no hay opciones disponibles.<br />
                                Presiona modificar para intentarlo nuevamente.
                            </div>
                    }


                </div>

            </div>
        </>
    )
}

export default ScheduleType
